rjQuery(window).load(function($) {
  setTimeout(function() {
    rjQuery('#shopify-product-reviews').appendTo(rjQuery('.ui-accordion.reviews .ui-accordion-content'));
    rjQuery('.ui-accordion.reviews .count').text(rjQuery('.spr-review').length);
  }, 2000);
})
$(document).ready(function($) {
  $('.nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.for',
    infinite: false,
    fade: false,
    dots: false,
    vertical: true,
    arrows: false,
    centerMode: false,
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: false,
    focusOnSelect: true
  });

  $('.for').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.nav',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true
        }
      }
    ]
  });

  $('.ui-accordion-header').on('click', function() {
    if($(this).closest('.ui-accordion').hasClass('opened')) {
      $(this).closest('.ui-accordion').removeClass('opened');
    } else {
      $(this).closest('.ui-accordion').addClass('opened');
    }
  });

  $(document).on('click', function(e) {
    if($('.js_load_more').is(e.target)) {
      $('.spr-review').show();
      $('.js_load_more').hide();
    }

    if (
      !$('.Product__Info_DropDown').is(e.target) &&
      !$('.Product__Info_DropDown_Call').is(e.target) &&
      !$('.QuantitySelector__Button').is(e.target) &&
      !$('.QuantitySelector__CurrentQuantity').is(e.target)
    ) {
      $('.Product__Info_DropDown').removeClass('fadeInDown');
      $('.Product__Info_DropDown_Call').removeClass('opened');
    }
  });

  $('.Product__Info_DropDown_Call').on('click', function(e) {
    if($(this).hasClass('opened')) {
      $('.Product__Info_DropDown').removeClass('fadeInDown');
      $('.Product__Info_DropDown_Call').removeClass('opened');
    } else {
      $('.Product__Info_DropDown').removeClass('fadeInDown');
      $('.Product__Info_DropDown_Call').removeClass('opened');
      $(this).addClass('opened')
      $(this).siblings('.Product__Info_DropDown').addClass('fadeInDown');
    }
  });

  $(document).on("click", ".ProductForm__Error", function() {
    $(this).remove();
  });

  $('.ProductForm__AddToCart').on("click", function() {
    $('.ProductForm__Error').remove();
  });
});